import jwt_decode from 'jwt-decode';

export const getCookie = (name) => {
    /*
    Function returns a map of key value pairs of document cookies.
    Optionally accepts a param name and return the cookie with the name.
     */
    let cookies = {};
    document.cookie.split(";").map(cookie => {
        cookie = cookie.trim();
        let keyValuePair = cookie.split("=");
        cookies[keyValuePair[0]] = keyValuePair[1];
    });
    return (name ? cookies[name] : cookies)
};


export const setCookie = ({ name, value, expires }) => {
  /*
  Sets a cookie with the given name and value
  expires (Optional) in milliseconds
  Adds domain if running in dev and global.public_cookie_domain exists
  Adds SameSite attribute: 'Strict' for production, 'None' otherwise
  */

  let expiresStr = "";
  if (expires) {
    let date = new Date();
    date.setTime(date.getTime() + expires);
    expiresStr = "; expires=" + date.toUTCString();
  }

  const APP_ENV = typeof global !== "undefined" && global.config ? global.config.application_env : "production";
  const isDev = APP_ENV === "dev";

  let domainStr = "";
  if (isDev && typeof global !== "undefined" && global.public_cookie_domain) {
    domainStr = "; domain=" + global.public_cookie_domain;
  }

  const sameSiteStr = `; SameSite=${APP_ENV === "production" ? "Strict" : "None"}`;

  document.cookie = name + "=" + (value || "") + expiresStr + domainStr + sameSiteStr + "; path=/";
};



export const refreshAuthToken = async (clientIp) => {
  try {
    let refreshToken = getCookie("dairftkn");
    const query = clientIp
      ? `
        mutation RefreshToken($refreshToken: String!, $clientIp: String) {
          RefreshToken(input: { refresh_token: $refreshToken, clientIp: $clientIp }) {
            access_token
          }
        }
      `
      : `
        mutation RefreshToken($refreshToken: String!) {
          RefreshToken(input: { refresh_token: $refreshToken }) {
            access_token
          }
        }
      `;

    const variables = clientIp
      ? { refreshToken, clientIp }
      : { refreshToken };

    const response = await fetch(`${global.config.designs_ai_auth_server_path}graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query, variables }),
    });

    const result = await response.json();

    const access_token =
      result &&
      result.data &&
      result.data.RefreshToken &&
      result.data.RefreshToken.access_token;

    if (access_token) {
        setCookie({name: 'daitkn', value: access_token, expires: 15, path: '/'});
      return access_token;
    } else {
      return {
        error:
          (result.errors && result.errors[0] && result.errors[0].message) ||
          'Unknown error'
      };
    }
  } catch (error) {
    return { error };
  }
};


export const getAccessToken = () => {
    let accessToken = getCookie('daitkn');
    var decodedJwtToken = accessToken ? jwt_decode(accessToken) : null;
    if (!decodedJwtToken) {
        console.log("User not logged in.");
        return null;
    }

    return (Date.now() < decodedJwtToken['exp'] * 1000) ? accessToken : refreshAuthToken();
};


export const getUserDetails = async () => {
    try {
        let accessToken = getAccessToken();
        let headers = {"Content-Type": "application/json"};
        headers["Authorization"] = accessToken;
        let url = global.config.server_path + 'user/user-details?c='+global.config.mm_client_id;
        let resp = await fetch(url, {method: 'GET', headers});
        return await resp.json();
    } catch (e) {
        console.error("Error while fetching user details,", e);
        return null;
    }
};
